"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconReddit = void 0;

var React = __importStar(require("react"));

exports.IconReddit = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, _excluded);

  return React.createElement("svg", _objectSpread(_objectSpread({
    width: "32",
    height: "32",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef
  }), React.createElement("path", {
    d: "M32 15.6464C32 13.312 30.4107 11.4144 28.4573 11.4144C27.504 11.4144 26.64 11.872 26.004 12.608C23.5907 10.7024 20.3253 9.4896 16.7093 9.3344L18.6867 1.864L24.0413 3.3696L24.0333 3.4624C24.0333 5.3712 25.3333 6.9232 26.932 6.9232C28.5293 6.9232 29.828 5.3712 29.828 3.4624C29.828 1.5536 28.528 0 26.932 0C25.7053 0 24.66 0.9184 24.2373 2.2064L18.4653 0.5824C18.2133 0.5088 17.9573 0.6832 17.8787 0.9808L15.6733 9.312C11.8893 9.3664 8.46133 10.5888 5.94 12.552C5.308 11.8512 4.46933 11.4128 3.54133 11.4128C1.588 11.4128 0 13.312 0 15.6464C0 17.1984 0.710667 18.544 1.756 19.28C1.68667 19.7312 1.64133 20.1872 1.64133 20.6512C1.64133 26.9088 8.052 32 15.9333 32C23.8147 32 30.2267 26.9088 30.2267 20.6512C30.2267 20.2128 30.188 19.7808 30.1267 19.3552C31.236 18.64 32 17.256 32 15.6464ZM9.03467 18.552C9.03467 17.1632 9.98133 16.032 11.144 16.032C12.3067 16.032 13.252 17.1632 13.252 18.552C13.252 19.9408 12.3067 21.0704 11.144 21.0704C9.98133 21.0704 9.03467 19.9408 9.03467 18.552ZM21.116 26.0224C20.0533 27.2912 18.3853 27.9088 16.0173 27.9088L16 27.904L15.9827 27.9088C13.6133 27.9088 11.9453 27.2912 10.884 26.0224C10.6907 25.792 10.6907 25.416 10.884 25.1856C11.0773 24.9536 11.392 24.9536 11.5853 25.1856C12.452 26.2208 13.8907 26.7232 15.9827 26.7232L16 26.728L16.0173 26.7232C18.1093 26.7232 19.548 26.2192 20.4147 25.184C20.608 24.952 20.9227 24.9536 21.116 25.184C21.3093 25.416 21.3093 25.7904 21.116 26.0224ZM20.864 21.0704C19.7013 21.0704 18.756 19.9408 18.756 18.552C18.756 17.1632 19.7013 16.032 20.864 16.032C22.0267 16.032 22.972 17.1632 22.972 18.552C22.972 19.9408 22.0267 21.0704 20.864 21.0704Z",
    fill: color
  }));
});